import moment from 'moment';

export const formatForSave = (data, id, applicationTypeId, fileGroups, customFiles = [], customQuestionnaires = [], agreements = null) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        if (data[key] === '') data[key] = null;
        else if (data[key] instanceof Date && !Number.isNaN(data[key])) {
            data[key] = moment(data[key]).format('YYYY-MM-DDTHH:mm');
        }
        if (key === 'questionnaire') {
            let counter = 0;
            const questionnaire = data.questionnaire;
            questionnaire?.forEach((q) => {
                let aCounter = 0;
                if (q?.answers !== '') {
                    q?.answers?.forEach((a) => {
                        formData.append(`questionnaire[${counter}].answers[${aCounter}].questionId`, a?.question);
                        let ansCounter = 0;
                        a?.answer?.forEach((answ) => {
                            formData.append(`questionnaire[${counter}].answers[${aCounter}].answer[${ansCounter}]`, answ);
                            ansCounter += 1;
                        });
                        aCounter += 1;
                    });
                }
                formData.append(`questionnaire[${counter}].questionnaireId`, q?.questionnaireId);
                counter += 1;
            });
        } else if (key === 'questionnaires') () => {};
        else if (key === 'orgSites') {
            const sites = data.orgSites;
            sites.forEach((site, index) => {
                if (site?.Id) formData.append(`orgSites[${index}].Id`, site?.Id);
                formData.append(`orgSites[${index}].SiteId`, site?.SiteId);
                formData.append(`orgSites[${index}].Abbr`, site?.Abbr);
                formData.append(`orgSites[${index}].IsActive`, site?.IsActive);
            });
        } else if (data[key] !== null) {
            formData.append(key, data[key]);
        }
    });

    formData.append('actionId', 'save');
    formData.append('applicationTypeId', applicationTypeId);
    if (id !== '0') formData.append('id', id);

    let fileCounter = 0;
    fileGroups?.forEach((group) => {
        group?.bundles?.forEach((bundle) => {
            bundle?.files?.forEach((file, index) => {
                // #EIT 2024/10/23: Το κλεινω γιατι παρατηρησα οτι εάν γινουν
                // τροποποιήσεις στα πεδία των attachments οι τιμές δεν περνάνε
                // μαζι με τα data της φόρμας, οπότε υπολογισμοί όπως αλλαγη στα DateFrom-DateTo
                // των officials από τα αρχεια της συμβασης δεν δούλευαν
                // if (!file?.saved) {
                formData.append(`Files[${fileCounter}].BundleId`, bundle?.id);
                formData.append(`Files[${fileCounter}].OrigFName`, file?.name);
                formData.append(`Files[${fileCounter}].File`, file?.fileObject);
                formData.append(`Files[${fileCounter}].FileTypeId`, group?.id);
                formData.append(`Files[${fileCounter}].FileName`, file?.name);
                formData.append(`Files[${fileCounter}].Comments`, bundle?.values?.comments);
                formData.append(`Files[${fileCounter}].DateFrom`, bundle?.values?.dateFrom);
                formData.append(`Files[${fileCounter}].DateTo`, bundle?.values?.dateTo);
                formData.append(`Files[${fileCounter}].IssuedAt`, bundle?.values?.issuedAt);
                formData.append(`Files[${fileCounter}].IssuedBy`, bundle?.values?.issuedBy);
                formData.append(`Files[${fileCounter}].Number`, bundle?.values?.number);
                formData.append(`Files[${fileCounter}].CommonId`, bundle?.values?.common);
                formData.append(`Files[${fileCounter}].Id`, file?.dbId);
                formData.append(`Files[${fileCounter}].Position`, index + 1);
                fileCounter += 1;
                // }
            });
        });
    });

    if (customFiles?.length > 0) {
        customFiles.forEach((item, index) => {
            formData.append(`files[${index}].personFunctionId`, item.personFunctionId);
            formData.append(`files[${index}].functionId`, item.functionId);

            // Handling "bundles" array
            item.bundles.forEach((bundle, bIndex) => {
                formData.append(`files[${index}].bundles[${bIndex}]`, bundle);
            });
        });
    }

    if (customQuestionnaires?.length > 0) {
        const filteredQuestionnaires = customQuestionnaires.filter(Boolean).flat();

        let counter = 0;

        // Flatten the array to get all questionnaires in a single list

        filteredQuestionnaires.forEach((q) => {
            formData.append(`Questionnaires[${counter}].FunctionId`, q?.functionId);
            formData.append(`Questionnaires[${counter}].PersonFunctionId`, q?.personFunctionId);
            formData.append(`Questionnaires[${counter}].AnswerSets[0].questionnaireId`, q?.questionnaireId);
            let aCounter = 0;
            if (q?.answers !== '') {
                q?.answers?.forEach((a) => {
                    formData.append(`Questionnaires[${counter}].AnswerSets[0].answers[${aCounter}].questionId`, a?.question);
                    let ansCounter = 0;
                    a?.answer?.forEach((answ) => {
                        formData.append(`Questionnaires[${counter}].AnswerSets[0].answers[${aCounter}].answer[${ansCounter}]`, answ);
                        ansCounter += 1;
                    });
                    aCounter += 1;
                });
            }
            counter += 1;
        });

        if (agreements) {
            Object.keys(agreements).forEach((key, index) => {
                formData.append(`agreements[${index}].Datakey`, key);
                formData.append(`agreements[${index}].Datavalue`, agreements[key]);
            });
        }
    }

    return formData;
};
